import { useEventCallback } from '@mui/material';
import { FakeDropdownBox } from '../../../filters';
import {
  IssueRelationshipCountMultipleSelector,
  type TransformedIssueRelationshipCountDto,
} from '../../../inputs';
import type { ExtendedGridColumnHeaderProps } from '../../types';
import { useDataGridContext } from '../../data-grid-context';
import { ContainerPopper } from './container-popper';

export function DataGridIssueRelationshipCountFilter(
  params: ExtendedGridColumnHeaderProps,
) {
  const context = useDataGridContext();
  const value: TransformedIssueRelationshipCountDto[] =
    context.filterModel[params.field] ?? [];

  const handleChange = useEventCallback(
    (value: TransformedIssueRelationshipCountDto[]) => {
      context.setFilterModel((prevState) => ({
        ...prevState,
        [params.field]: value,
      }));
    },
  );

  return (
    <ContainerPopper
      renderTarget={(props) => (
        <FakeDropdownBox onClick={props.handleClick}>
          {value.length > 0
            ? value.map((issue) => issue.relationshipCount).join(', ')
            : null}
        </FakeDropdownBox>
      )}
      renderChildren={(props) => (
        <IssueRelationshipCountMultipleSelector
          open
          value={value}
          onChange={handleChange}
          onClose={props.handleClose}
          TextFieldProps={{
            autoFocus: true,
          }}
        />
      )}
    />
  );
}
